import React, { ReactNode } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import CenteredPanel from '../../atoms/centered-panel/centered-panel';
import { Copyright } from '../../atoms/copyright/copyright';
import LoginHeader from '../../molecules/login-header/login-header';
import LogosRow from '../../molecules/logos-row/logos-row';
import { width, mt, height, flex } from '../../style-utils';

export interface LoginPageTemplateProps {
  title?: string;
  logo?: ReactNode;
  backgroundColor?: string;
  copyright?: string;
  showLogos?: boolean;
  style?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
}

export const LoginPageTemplate: React.FC<LoginPageTemplateProps> = ({
  children,
  title,
  logo,
  backgroundColor,
  copyright,
  showLogos,
  style,
}) => {
  const renderFooter = () => {
    if (!showLogos) {
      return null;
    }

    return (
      <View style={[width(400), mt(20)]}>
        <LogosRow />
      </View>
    );
  };

  return (
    <>
      <CenteredPanel
        backgroundColor={backgroundColor}
        footer={renderFooter()}
        style={[height(undefined), flex('flex-1'), style]}
      >
        <LoginHeader title={title} logo={logo} />
        {children}
      </CenteredPanel>
      {copyright && <Copyright>{copyright}</Copyright>}
    </>
  );
};

export default LoginPageTemplate;
